import { render, staticRenderFns } from "./TherapyTextBox.vue?vue&type=template&id=4e8818ce"
import script from "./TherapyTextBox.vue?vue&type=script&lang=js"
export * from "./TherapyTextBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports